import { render, staticRenderFns } from "./ReceiveContractModal.vue?vue&type=template&id=20e6b1b0&scoped=true&lang=pug"
import script from "./ReceiveContractModal.vue?vue&type=script&lang=js"
export * from "./ReceiveContractModal.vue?vue&type=script&lang=js"
import style0 from "./ReceiveContractModal.vue?vue&type=style&index=0&id=20e6b1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6b1b0",
  null
  
)

export default component.exports